import { ParallaxTextProps } from '../../../types/ParallaxTextTypes';

const auditCyberParallaxText: ParallaxTextProps = {
  leftTitle: '',
  leftText: '',
  rightTitle: '',
  rightText: '',
};

export default auditCyberParallaxText;